export default "__VITE_ASSET__BaDOuCp7__"